import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ShieldAlert, Mail, ArrowLeft } from "lucide-react";
import { CONTACT_FALLBACK } from "@/lib/api";

export default function NoAccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const contact = location.state?.contact || CONTACT_FALLBACK;
  const email = location.state?.email;

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden text-center" data-testid="no-access-card">
        <div className="bg-guinda/10 px-8 py-8">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-guinda/15 flex items-center justify-center">
            <ShieldAlert className="w-9 h-9 text-guinda" />
          </div>
        </div>
        <div className="px-8 py-7">
          <h1 className="font-heading text-xl font-bold text-slate-900 mb-2">Acceso no autorizado</h1>
          <p className="text-sm text-slate-600 mb-1">
            La cuenta de Google{email ? ` ${email}` : ""} no está autorizada para acceder a esta aplicación.
          </p>
          <p className="text-sm text-slate-600 mb-5">
            Para solicitar acceso, contacta al administrador:
          </p>
          <a href={`mailto:${contact}?subject=Solicitud de acceso - Plataforma Territorial Tampico`}
            data-testid="contact-link"
            className="inline-flex items-center gap-2 rounded-xl bg-guinda hover:bg-guinda-dark text-white font-semibold text-sm px-5 h-11 transition-colors">
            <Mail className="w-4 h-4" /> {contact}
          </a>
          <div className="mt-6">
            <button data-testid="back-login-btn" onClick={() => navigate("/login", { replace: true })}
              className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-guinda">
              <ArrowLeft className="w-4 h-4" /> Volver a iniciar sesión
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
